import React, { useContext, useEffect, useRef, useState } from "react";
import cx from "classnames";
import { Button } from "reactstrap";
import { Link, useRouteMatch } from "react-router-dom";

import Utils from "../../helpers/Utils";

import Logo from "../Logo/Logo";
import DatasourceSwitchIcon from "../Icon/icons/general/DatasourceSwitchIcon";
import PencilIcon from "../Icon/icons/general/PencilIcon";
import HomeIcon from "../Icon/icons/general/HomeIcon";
import PathHelper from "../../pages/web/PathHelper";

import LOCAL_STORAGE from "../../_redux/localStorage";

import s from "./WeaveTopBar.module.scss";
import MarketPlaceContext from "../../pages/web/market/MarketPlaceContext";

export default function WeaveTopBar(props) {
	// onFill: fill-in the fields with demo data
	// onFileLoadComplete: user triggers custom file upload
	const { onFill, onFileLoadComplete, root = "/" } = props;
	const uploadRef = useRef(null);

	const { showHomeIcon } = useContext(MarketPlaceContext) || {};

	const [showAutofill, setShowAutofill] = useState(false);

	const rootPath = PathHelper.getPath("market");

	useEffect(() => {
		let oldState = LOCAL_STORAGE.loadState() || {};

		let showPencil = oldState.useMocks;

		// Force DEMO mode on initial load unless user previously toggled EDIT mode
		// Removed 2022.11.01
		/* if (isElectronApp() && oldState.useMocks === undefined) {
			showPencil = true;
			LOCAL_STORAGE.saveState({
				...oldState,
				useMocks: true,
			});
		} */

		// 2022.10.26 Dont show pencil if not demo mode
		setShowAutofill(showPencil);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// ------------------------------------- METHODS -------------------------------------
	const uploadDemoFile = () => {
		uploadRef.current.click();
	};

	const loadFileContent = (file) => {
		const reader = new FileReader();
		reader.onload = (e) => {
			const fileContent = e.target.result;

			try {
				onFileLoadComplete(JSON.parse(fileContent));
			} catch (error) {
				//
			}
		};
		reader.readAsText(file);
	};

	return (
		<div className={cx(s.root, props.className)}>
			{onFileLoadComplete && (
				<input
					ref={uploadRef}
					type="file"
					accept=".json"
					onChange={(ev) => loadFileContent(ev.target.files[0])}
					style={{ display: "none" }}
				/>
			)}

			{props.goBack ? (
				<Button
					className={cx(s.backButton, "btn-border")}
					color="info"
					onClick={props.goBack}
				>
					<i className="fa fa-arrow-left" />
					<span>Back</span>
				</Button>
			) : showHomeIcon ? (
				<Link to={rootPath} className={s.homeIcon}>
					<HomeIcon />
				</Link>
			) : null}

			<div className={s.title}>
				<Logo url={root} />
			</div>

			{/* Market place avatar */}
			{props.children && <>{props.children}</>}

			<div
				className={cx(s.iconsContainer, props.hasAvatar ? s.withAvatar : "")}
			>
				{/* Auto fill values into page inputs */}
				{showAutofill && onFill && (
					<div onClick={onFill} className={s.fillIcon}>
						<PencilIcon width={16} height={16} />
					</div>
				)}

				{/* Load file config */}
				{showAutofill && onFileLoadComplete && (
					<div onClick={uploadDemoFile} className={s.fillIcon}>
						<PencilIcon width={16} height={16} />
					</div>
				)}

				{/* Toggle demo/real data modes */}
				{!props.hideDatasource && (
					<div
						onClick={() => Utils.toggleMockedData()}
						className={s.dataSourceIcon}
					>
						<DatasourceSwitchIcon />
					</div>
				)}
			</div>
		</div>
	);
}
